var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 60,
    viewBox: "0 0 44 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3201_52944)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37454 0H27.4345L44.436 17.7212V52.1889C44.436 56.5068 40.9428 60 36.6399 60H7.37454C3.05672 60 -0.436523 56.5068 -0.436523 52.1889V7.81107C-0.436599 3.49324 3.05664 0 7.37454 0Z",
    fill: "#FF6A55"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4194 0V17.5862H44.4359L27.4194 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0073 27.2264C16.655 27.2264 12.3071 31.5743 12.3071 36.9266C12.3071 42.2789 16.655 46.6117 22.0073 46.6117C27.3596 46.6117 31.6925 42.2789 31.6925 36.9265C31.6925 31.5742 27.3446 27.2414 22.0073 27.2264ZM26.0853 37.2264C26.0103 37.3614 25.9054 37.4663 25.7704 37.5413L20.2382 40.3149C19.8933 40.4797 19.4736 40.3449 19.3087 40C19.2487 39.91 19.2337 39.8051 19.2337 39.6852V34.153C19.2337 33.7631 19.5486 33.4633 19.9234 33.4633C20.0283 33.4633 20.1333 33.4783 20.2382 33.5383L25.7704 36.2969C26.1153 36.4768 26.2502 36.8816 26.0853 37.2264Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3201_52944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlaceholder);
export default __webpack_public_path__ + "static/media/video_placeholder.f55c25a4ed7745466c2be02c5f47f890.svg";
export { ForwardRef as ReactComponent };